import { Button as _Button } from "./button";
import { ButtonContent } from "./button-content";
import { ButtonIcon } from "./button-icon";
const Button = _Button;
Button.Content = ButtonContent;
Button.Icon = ButtonIcon;
export { Button };
